import { Months } from "@/enums/months.enum";

export const es = {
  dashboard: {
    title: "Inicio",
    welcome: "Bienvenido de nuevo",
    currentMonth: "Este mes",
    budget: {
      totalBudget: "Presupuesto Total",
      remaining: "Restante",
      spent: "Gastado",
      dailySpend: "Gasto Diario",
      projection: "Proyección",
      potentialSavings: "Ahorro Estimado",
      smartLabel: "inteligente",
      endOfMonth: "al cierre del mes",
      vsOriginal: "vs. presupuesto original",
      remainingBudget: "Presupuesto restante",
      fixedRemaining: "Fijos restantes (est.)",
      availableForVariable: "Disponible para variables",
      historicalVariable: "Variable histórico",
      currencyArs: "ARS",
      currencyUsd: "USD",
      months: {
        march: "Marzo '24",
        april: "Abril '24",
        may: "Mayo '24",
      },
      navigation: {
        previous: "Mes anterior",
        next: "Mes siguiente",
      },
      tooltips: {
        dailySpend:
          "Cantidad máxima que podés gastar por día para mantenerte dentro del presupuesto. Calculado como el saldo restante dividido los días que faltan.",
        dailySpendSmart:
          "Gasto diario inteligente basado en tus últimos 6 meses. Resta automáticamente los gastos fijos que aún no pagaste este mes para darte un número más realista de cuánto podés gastar en variables.",
        projectionCurrent:
          "Proyección basada en tu gasto promedio actual del mes. Si los primeros días tenés gastos atípicos (servicios, tarjetas), esta cifra puede ser inexacta.",
        projectionHistorical:
          "Proyección calculada con el promedio diario de tus últimos 3 meses. Es más estable y no se ve afectada por gastos inusuales al inicio del mes.",
        savings:
          "Diferencia entre tu presupuesto y la proyección de gastos. Valor positivo = ahorro potencial. Valor negativo = riesgo de exceder tu presupuesto.",
      },
    },
    expenseAnalysis: {
      title: "Análisis de Gastos",
      subtitle: "Evolución diaria de tus gastos",
      amount: "Monto",
      estimated: "Estimado",
      accumulated: "Acumulado",
      estimatedAccumulated: "Estimado Acumulado",
      deviation: "Desviación",
    },
    monthlySummary: {
      title: "Resumen del Mes",
      subtitle: "Distribución por categorías",
    },
    recentTransactions: {
      title: "Últimas Transacciones",
      subtitle: "Historial de movimientos recientes",
      viewAll: "Ver todas",
      empty: "No hay transacciones recientes",
      error: {
        title: "Error al cargar transacciones",
        message: "No pudimos cargar tus últimas transacciones. Intentalo de nuevo.",
        retry: "Reintentar",
      },
    },
    accounts: {
      title: "Cuentas",
      subtitle: "Saldos de tus cuentas",
      viewAll: "Ver billetera",
      empty: {
        title: "No tenés cuentas creadas aún",
        action: "Crear tu primera cuenta",
      },
      error: {
        message: "No pudimos cargar tus cuentas.",
        retry: "Reintentar",
      },
    },
    error: {
      title: "Error al cargar el dashboard",
      message: "No pudimos cargar la información de tu presupuesto. Intentalo de nuevo.",
      retry: "Reintentar",
    },
    emptyChart: {
      title: "Sin gastos registrados",
      message: "No hay gastos registrados este mes. ¡Empezá a registrar tus gastos para ver el análisis aquí!",
    },
    greeting: "Hola, {name}",
    hero: {
      greeting: "Buen día, {name}.",
      remainingDaily: "Te quedan {amount}/día.",
      remainingDailyArs: "En pesos: {amount}/día",
      updating: "Actualizando...",
      cachedBadge: "Datos del cache",
      retry: "Reintentar",
      emptyTitle: "Configurá tu presupuesto para arrancar",
      emptyAction: "Configurar presupuesto",
      comparisonUp: "Mejor que el mes pasado",
      comparisonDown: "Peor que el mes pasado",
    },
    budgetDetail: {
      projectedBadge: "Proyectado",
      title: "Tu presupuesto",
      spent: "Gastado",
      remaining: "Restante",
      total: "Total",
      fixed: "Fijos",
      variable: "Variables",
      spentArs: "Gastado (ARS)",
      totalArs: "Tope (ARS)",
      remainingArs: "Restante (ARS)",
      of: "{percent}% del total",
    },
    cclSnapshot: {
      title: "Dólar CCL",
      variationUp: "Sube",
      variationDown: "Baja",
      variationFlat: "Estable",
      impactGain: "Tus USD rinden ${amount} más en pesos",
      impactLoss: "Tus USD rinden ${amount} menos en pesos",
      noData: "—",
      cached: "Sin conexión",
    },
    spendingTimeline: {
      title: "Últimos 7 días",
      empty: "Tus gastos van a aparecer acá",
      weekLabel: "Esta semana",
      deltaUp: "+{percent}% vs. semana anterior",
      deltaDown: "-{percent}% vs. semana anterior",
      deltaFlat: "Igual que la semana anterior",
    },
    quickStats: {
      totalExpensesUsd: "Gastos Totales (USD)",
      totalExpensesArs: "Gastos Totales (ARS)",
      remainingBudget: "Presupuesto Restante",
      mainCategory: "Categoría Principal",
      vsLastMonth: "vs. mes anterior",
    },
  },
  quickAdd: {
    placeholder: "Agregar gasto rápido",
    ariaExpand: "Agregar un gasto",
    amountLabel: "Monto",
    amountPlaceholder: "0",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "¿En qué gastaste?",
    categoryLabel: "Categoría",
    categoryEmpty: "Sin categorías",
    dateLabel: "Fecha",
    dateToday: "Hoy",
    accountLabel: "Cuenta",
    noAccount: "Sin cuenta",
    selectAccount: "Elegí la cuenta",
    submit: "Guardar",
    submitting: "Guardando...",
    cancel: "Cancelar",
    success: "Gasto guardado",
    error: {
      notAuthenticated: "Necesitás iniciar sesión para guardar un gasto",
      noExchangeRate: "No hay tasa de cambio disponible, intentá en unos segundos",
      generic: "No pudimos guardar el gasto",
      retry: "Reintentar",
    },
    validation: {
      amountRequired: "Ingresá un monto",
      amountPositive: "El monto debe ser mayor a 0",
      descriptionRequired: "Ingresá una descripción",
      categoryRequired: "Elegí una categoría",
      dateRequired: "Elegí una fecha",
    },
  },
  navigation: {
    home: "Inicio",
    categories: "Categorías",
    budget: "Presupuesto",
    profile: "Perfil",
    expenses: "Nuevo gasto",
    transactions: "Transacciones",
    dashboard: "Inicio",
    movements: "Movimientos",
    analysis: "Análisis",
    chat: "Chat",
    wallet: "Billetera",
  },
  layout: {
    appName: "Contablix",
    profile: {
      signedInAs: "Conectado como",
      settings: "Configuración",
      logout: "Cerrar sesión",
    },
  },
  expenses: {
    wizard: {
      steps: {
        basicInfo: "Información Básica",
        category: "Selecciona una Categoría",
        account: "Selecciona una Cuenta",
        date: "Fecha del Gasto",
      },
      stepIndicator: "Paso {step} de {total}",
      validationError: "Revisá los campos marcados para continuar",
      success: {
        title: "¡Gasto guardado con éxito!",
        subtitle: "Tu gasto ha sido registrado correctamente en el sistema",
        action: "Ir al Dashboard",
      },
    },
    form: {
      amount: {
        placeholder: "0.00",
      },
      description: {
        label: "Descripción",
      },
      date: {
        label: "Hora",
        helper: "Selecciona la hora del gasto",
      },
      actions: {
        continue: "Continuar",
        save: "Guardar Gasto",
        saving: "Guardando...",
        done: "Listo",
      },
      expenseType: {
        expense: "Gasto",
        income: "Ingreso",
      },
    },
    categories: {
      select: "Elegí una categoría",
      new: {
        button: "Nueva Categoría",
        modal: {
          title: "Crear Nueva Categoría",
          name: "Nombre",
          description: "Descripción",
          icon: "Ícono",
          iconPlaceholder: "Selecciona un ícono",
          actions: {
            cancel: "Cancelar",
            create: "Crear Categoría",
          },
          errors: {
            required: "Todos los campos son requeridos",
          },
        },
      },
    },
  },
  budget: {
    management: {
      title: "Gestión de Presupuesto",
      subtitle: "Administra y controla tu presupuesto mensual",
    },
    currentBudget: "Presupuesto de {month} {year}",
    totalBudget: "Presupuesto Total",
    remaining: "Restante",
    spent: "Gastado",
    selectMonth: "Seleccionar mes",
    actions: {
      modify: "Modificar",
      setBudget: "Establecer Presupuesto",
      save: "Guardar",
    },
    placeholders: {
      amount: "Ingresa el monto",
    },
    history: {
      title: "Historial de Presupuestos",
      empty: "No hay registros de presupuestos anteriores",
    },
    months: {
      [Months.JANUARY]: "Enero",
      [Months.FEBRUARY]: "Febrero",
      [Months.MARCH]: "Marzo",
      [Months.APRIL]: "Abril",
      [Months.MAY]: "Mayo",
      [Months.JUNE]: "Junio",
      [Months.JULY]: "Julio",
      [Months.AUGUST]: "Agosto",
      [Months.SEPTEMBER]: "Septiembre",
      [Months.OCTOBER]: "Octubre",
      [Months.NOVEMBER]: "Noviembre",
      [Months.DECEMBER]: "Diciembre",
    },
    title: "Presupuesto Mensual",
    emptyState: {
      title: "¿Listo para planificar tu mes?",
      description: "Crea un presupuesto para controlar tus gastos y tomar el control de tus finanzas.",
      action: "Establecer Presupuesto Mensual",
      placeholders: {
        usd: {
          title: "El Ancla (USD)",
          description: "Tu resumen en USD aparecerá aquí.",
        },
        ars: {
          title: "Vista Operativa (ARS)",
          description: "Tus gastos en ARS aparecerán aquí una vez establecido el presupuesto.",
        },
      },
    },
    activeState: {
      status: {
        onTrack: "Estado Global: En Camino",
        warning: "Estado Global: Advertencia",
        overBudget: "Estado Global: Excedido",
      },
      usdCard: {
        title: "El Ancla",
        subtitle: "Vista USD",
      },
      arsCard: {
        title: "Vista Operativa",
        subtitle: "Vista ARS - Peso Argentino",
        nominalSpent: "Gasto Nominal",
        projectedTotal: "Total Proyectado",
        availableNow: "Disponible Ahora",
      },
      exchangeRate: {
        text: "1 USD = {rate} ARS",
        lastUpdated: "Tipo de cambio actualizado: hace 2 mins",
      },
    },
    modal: {
      title: "Establecer Presupuesto Mensual",
      editTitle: "Editar Presupuesto Mensual",
      amountLabel: "Monto del Presupuesto (USD)",
      amountPlaceholder: "Ingresar monto",
      exchangeRateLabel: "Tipo de Cambio",
      exchangeRatePlaceholder: "Ingresar tipo de cambio",
      exchangeRateDescription: "Tipo de cambio ARS/USD para el cálculo de valores en pesos argentinos",
      settingBudgetFor: "Estableciendo presupuesto para",
      editingBudgetFor: "Editando presupuesto para",
      cancel: "Cancelar",
      save: "Guardar Presupuesto",
      update: "Actualizar Presupuesto",
    },
  },
  profile: {
    title: "Mi Perfil",
    logout: "Cerrar sesión",
    estimatedUsdIncome: {
      label: "Ingreso mensual en USD estimado",
      description: "Se usa para estimar cuánto rinden tus ingresos cuando cambia el dólar.",
      placeholder: "Ej: 2000",
      save: "Guardar",
      saving: "Guardando...",
      success: "Ingreso mensual actualizado",
      error: "No pudimos guardar tu ingreso mensual",
      invalid: "Ingresá un monto válido mayor o igual a 0",
    },
  },
  auth: {
    login: {
      title: "Bienvenido a Contablix",
      subtitle: "Gestiona tus finanzas de manera inteligente",
      googleButton: "Continuar con Google",
      switchToSignup: "¿No tienes cuenta? Regístrate",
      or: "o",
    },
    signup: {
      title: "Crear una cuenta",
      subtitle: "Comienza a gestionar tus finanzas",
      name: "Nombre completo",
      email: "Correo electrónico",
      password: "Contraseña",
      submit: "Crear cuenta",
      switchToLogin: "¿Ya tienes cuenta? Inicia sesión",
      or: "o",
    },
    termsText: "Al continuar, aceptas nuestros",
    termsLink: "Términos de servicio",
    and: "y",
    privacyLink: "Política de privacidad",
  },
  common: {
    periods: {
      week: "Semana",
      month: "Mes",
    },
    amount: "Monto",
    description: "Descripción",
    category: "Categoría",
    date: "Fecha",
    noDescription: "Sin descripción",
  },
  wallet: {
    title: "Billetera",
    subtitle: "Gestiona tus cuentas y tarjetas",
    total: {
      label: "Total en USD",
    },
    actions: {
      add: "Nueva Cuenta",
    },
    empty: {
      title: "No tenés cuentas creadas aún",
      action: "Crear primera cuenta",
    },
    error: {
      load: "Error al cargar las cuentas",
    },
    modal: {
      title: "Nueva Cuenta",
      editTitle: "Editar Cuenta",
      name: "Nombre",
      namePlaceholder: "Ej: Banco Galicia, Efectivo...",
      type: "Tipo de cuenta",
      currency: "Moneda",
      color: "Color",
      initialBalance: "Saldo inicial",
      currentBalance: "Balance actual",
      currentBalanceHint:
        "El saldo de movimientos anteriores se ajusta automáticamente para que la cuenta arranque desde este valor.",
      cancel: "Cancelar",
      create: "Crear Cuenta",
      save: "Guardar",
    },
    wizard: {
      step: "Selecciona una Cuenta",
      selectAccount: "¿De qué cuenta sale este gasto?",
      noAccount: "Sin cuenta asignada",
    },
    default: {
      set: "Establecer como predeterminada",
      clear: "Quitar como predeterminada",
      badge: "Predeterminada",
    },
    transfer: {
      title: "Transferir entre cuentas",
      button: "Transferir",
      from: "Desde",
      to: "Hacia",
      amount: "Monto",
      date: "Fecha",
      time: "Hora",
      hour: "Hora",
      minute: "Minutos",
      conversion: "Conversión",
      rate: "Tipo de cambio (ARS por USD)",
      rateBuyHint: "Ingresá el rate de compra",
      rateError: "No se pudo obtener el tipo de cambio",
      action: "Transferir",
      saving: "Transfiriendo...",
      success: "Transferencia realizada con éxito",
      error: "Error al realizar la transferencia",
    },
  },
  pwa: {
    install: {
      title: "Instalar Contablix",
      description: "Agregá Contablix a tu pantalla de inicio para acceder rápidamente.",
      button: "Instalar",
      dismiss: "Ahora no",
    },
    offlineReady: "App lista para uso sin conexión",
    ios: {
      instructions: 'Para instalar: tocá el botón Compartir y luego "Agregar a pantalla de inicio".',
    },
  },
  analysis: {
    title: "Análisis de Gastos",
    subtitle: "Tu mes en curso y tu base histórica, en la misma vista.",
    mode: {
      month: "Mes",
      range: "Rango",
    },
    previousMonth: "Mes anterior",
    nextMonth: "Mes siguiente",
    selectRange: "Seleccioná un rango de fechas",
    speeds: {
      fast: "Este mes",
      slow: "Histórico",
    },
    pulse: {
      accumulated: "Gasto acumulado",
      elapsed: "Día {day} de {total}",
      rangeDays: "{total} días",
      barsLabel: "Gasto por día a lo largo de {days} días",
      baselineLegend: "Tu ritmo típico: {amount} por día",
      baselineHint: "Tu típico: {amount}/día",
      paceAbove: "{percent} sobre tu ritmo típico",
      paceBelow: "{percent} bajo tu ritmo típico",
      paceEven: "En línea con tu ritmo típico",
      paceNoBaseline: "Sin base histórica para comparar el ritmo",
      paceError: "No pudimos comparar con tu ritmo típico",
      dailyError: "No pudimos actualizar tu gasto del período",
      projectedClose: "Proyección al cierre",
      closedAt: "El mes cerró en",
      rangeAverage: "Promedio diario del rango",
      budget: "Presupuesto",
      budgetUsed: "{percent} usado",
      budgetRemaining: "Te quedan {amount}",
      budgetOver: "Excedido en {amount}",
      budgetNone: "Sin presupuesto definido para este mes",
      budgetError: "No pudimos cargar tu presupuesto",
      empty: "Todavía no hay gastos en este período. Cargá tu primer movimiento para ver tu ritmo.",
    },
    baseline: {
      title: "Tu base",
      perDay: "por día",
      monthly: "≈ {amount} por mes",
      monthsAnalyzed: "{count} meses analizados",
      empty: "No hay meses cerrados entre {from} y {to} para calcular tu base.",
      confidence: {
        high: "Confianza alta",
        medium: "Confianza media",
        low: "Confianza baja",
      },
    },
    momentum: {
      title: "Qué se movió",
      subtitle: "vs. mes anterior",
      share: "{percent} del gasto",
      previous: "antes {amount}",
      new: "Nueva",
      empty: "No hay meses anteriores para comparar.",
    },
    top: {
      title: "Mayores gastos",
    },
    totalExpenses: "Gastos Totales",
    categories: "Categorías",
    categoriesUsed: "Categorías utilizadas",
    amount: "{amount} USD",
    amountLabel: "Monto",
    avgDailyExpense: "Gasto Diario Promedio",
    topExpense: "Mayor Gasto del Período",
    period: "Período",
    perDay: "por día",
    daysLeft: "{days} días restantes",
    vsLastMonth: "vs mes anterior",
    expensesByCategory: "Gastos por Categoría",
    monthlyExpenseTrend: "Tendencia Mensual de Gastos",
    dailyExpenses: "Gastos Diarios",
    weeklyExpenses: "Gastos Semanales",
    topExpenses: "Gastos más Altos",
    expenses: "Gastos",
    otherCategories: "Otras Categorías",
    noDataAvailable: "No hay datos disponibles para el período seleccionado",
    percentage: "Porcentaje",
    selectedPeriod: "Período Seleccionado",
    amountARS: "Monto (ARS)",
    amountUSD: "Monto (USD)",
    filterByCategory: "Categorías",
    fixedVsVariable: {
      title: "Distribución de Gasto",
      subtitle: "Fijos vs. Flexibles",
      fixed: "Fijos",
      variable: "Variables",
      control: "Control",
      percentOfTotal: "{percent}% del total",
      tipIntro: "Tip:",
      tipText:
        "Tenés un {control}% de tu presupuesto con margen de maniobra. Reducir gastos en categorías variables es tu vía más rápida de ahorro.",
    },
    dollarHedge: {
      title: "Cobertura & Inflación",
      subtitle: "Rastreador de poder adquisitivo",
      cclTarget: "Dólar CCL",
      impactTarget: "Impacto en Ingresos",
      dollarUpImpact: "El dólar subió un ",
      dollarUpImpactEnd: " — tus ingresos rinden más en pesos.",
      dollarDownImpact: "El dólar bajó un ",
      dollarDownImpactEnd: " — tus ingresos rinden menos en pesos.",
      monetaryImpact: "Este mes, tus USD te {{difference}} en pesos frente al mes anterior",
      monetaryImpactGain: "dan ${{amount}} más",
      monetaryImpactLoss: "dan ${{amount}} menos",
      fixedExpenseImpact: "Eso equivale al {{percent}}% de tus gastos fijos del mes",
      rateTracker: "Tu dólar rinde",
      start: "Inicio",
      current: "Actual",
      noData: "Sin datos de cotización",
      missingIncome: "Configurá tu ingreso mensual en USD para estimar el impacto del dólar en tus finanzas.",
      missingIncomeAction: "Configurar ingreso",
      disclaimer: "* Basado en la variación del Dólar CCL desde el primer día del mes.",
    },
    categoryDelta: {
      title: "Variaciones Significativas",
      badge: "VS MES ANTERIOR",
      subtitle: "Categorías con mayores cambios en el gasto",
      vsPrevious: "{current} vs. {previous}",
      noData: "No hay datos suficientes para comparar.",
    },
    dailyChart: {
      title: "Ritmo de Gasto",
      subtitle: "Acumulado vs. Proyectado",
      projection: "Proyección",
      projectionHistorical: "Proyección Hist.",
      pacing: "Pacing (Desviación)",
      pacingVsIdeal: "Pacing vs. Ideal",
      disclaimer: "Línea punteada indica proyección basada en gasto actual.",
      confidenceText: "Basado en {count} meses",
      confidenceHigh: "Alta confianza",
      confidenceMedium: "Confianza media",
      confidenceLow: "Baja confianza",
    },
    pieChartCategory: {
      subtitle: "Distribución del gasto mensual",
      total: "Total",
    },
  },
} as const;
